class UniTimeline extends HTMLElement {
  constructor() {
    super();

    this.yearButtons = document.querySelectorAll(".timeline__year");
    this.timelineItems = document.querySelectorAll(".timeline__item");
    this.isScrolling = false;

    this.init();
  }

  init() {
    this.yearButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleYearClick(e));
    });

    window.addEventListener("scroll", () => this.handleScroll());

    this.updateActiveStates();
  }

  handleYearClick(e) {
    const button = e.currentTarget;
    const targetId = button.dataset.target || `item-${button.id}`;
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      this.isScrolling = true;

      // Update active button immediately for better UX
      this.setActiveButton(button);
      this.setActiveItem(targetElement);

      // Smooth scroll to target
      var headerHeight = document.getElementsByTagName("header")[0].offsetHeight + 10; // sticky header height
      window.scroll({ top: targetElement.offsetTop - headerHeight, left: 0, behavior: "smooth" });

      // Reset scrolling flag after animation completes
      setTimeout(() => {
        this.isScrolling = false;
      }, 1000);
    }
  }

  handleScroll() {
    // Don't update during programmatic scrolling
    if (this.isScrolling) return;

    // Debounce scroll events
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.updateActiveStates();
    }, 100);
  }

  updateActiveStates() {
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    let activeItem = null;
    let activeButton = null;

    // Find which item is currently in view
    this.timelineItems.forEach((item, index) => {
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;

      if (scrollPosition >= itemTop && scrollPosition <= itemBottom) {
        activeItem = item;
        activeButton = this.yearButtons[index];
      }
    });

    // If no item is perfectly in view, find the closest one
    if (!activeItem) {
      let closestDistance = Infinity;

      this.timelineItems.forEach((item, index) => {
        const itemCenter = item.offsetTop + item.offsetHeight / 2;
        const distance = Math.abs(scrollPosition - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeItem = item;
          activeButton = this.yearButtons[index];
        }
      });
    }

    if (activeItem && activeButton) {
      this.setActiveButton(activeButton);
      this.setActiveItem(activeItem);
    }
  }

  setActiveButton(activeButton) {
    this.yearButtons.forEach((button) => {
      button.classList.remove("active");
    });

    activeButton.classList.add("active");
  }

  setActiveItem(activeItem) {
    this.timelineItems.forEach((item) => {
      item.classList.remove("active");
    });
    activeItem.classList.add("active");
  }
}

if (customElements.get("uni-timeline") === undefined) {
  customElements.define("uni-timeline", UniTimeline);
}
